import script from "./ImageViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageViewer.vue?vue&type=script&setup=true&lang=ts"

import "./ImageViewer.vue?vue&type=style&index=0&id=24935402&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24935402"]])

export default __exports__